import React from 'react';
import QuestionContainer from './QuestionContainer';
import 'reactjs-popup/dist/index.css';
import { Box, Button } from '@mui/material';

function QuestionCanvas({ questionData, onDeleteQuestion, onChangeQuestion, onUpDownQuestion, onCreateNewQuestion }) {


    let questionIndex = 0;

    var qList = questionData.map(function (q) {

        return <Box sx={{ mt: '20px', backgroundColor: '#e9eef1' }}>
            <QuestionContainer index={questionIndex++} key={q.question.templateId} onUpDown={(dir) => onUpDownQuestion(dir, q)} selectedMode={true} data={q} onRemove={onDeleteQuestion} onDataChange={onChangeQuestion} ></QuestionContainer >
        </Box>

    });

    return (

        <Box sx={{ height: '100%', overflowY: 'auto', pl: '10px', pr: '20px' }}>
            <Button variant="contained" sx={{ marginRight: '5%' }} onClick={onCreateNewQuestion} >Create New</Button>

            <Box>
                {qList}
            </Box>


        </Box >
    )
};

export default QuestionCanvas;